import InputLabel from '@material-ui/core/InputLabel'
import { css } from 'styled-components'
import styled from 'styled-components/macro'
import media from 'styled-media-query'

export const Wrapper = styled.div``

export const TituloCard = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.font.sizes.xlarge};
  `}
  font-family: 'IBMPlexSans-Bold'
`

export const Label = styled(InputLabel)`
  font-family: 'IBMPlexSans-Bold';
  ${({ theme }) => css`
    font-size: ${theme.font.sizes.small};
    font-weight: 600;
  `};
`

export const LabelNomeViabilidade = styled(Label)`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`

export const LabelCenter = styled(Label)`
  text-align: end;

  ${media.lessThan('medium')`
    text-align: start;
  `}
`

export const LabelNumeroCondominios = styled(Label)`
  width: 180px;
  font-weight: bold;
`

export const LabelModelonegocio = styled(Label)`
  width: 180px;
  font-weight: bold;
`

export const DivCampos = styled.div`
  width: 100%;
  display: grid;
  flex-direction: column;
  grid-template-columns: 220px 1fr;

  ${media.lessThan('medium')`
   grid-template-columns: 220px 1fr;
  `}
`

export const GridPrincipal = styled.div`
  display: grid;
  flex-direction: column;
  grid-auto-flow: column;
  grid-template-columns: 1fr 136px 1fr 1fr;
  margin: 24px 0 0 0;
  column-gap: 36px;

  ${media.lessThan('medium')`
    grid-template-columns: 1fr;
    grid-template-rows: repeat(3,1fr);
    row-gap:24px;
    column-gap:0;
  `}

  ${media.between('medium', 'large')`
    grid-template-columns: repeat(3,1fr);
  `}

  ${media.greaterThan('huge')`
    column-gap: 112px;
  `}
`

export const GridSecundaria = styled.div`
  display: grid;
  flex-direction: row;
  row-gap: 8px;
  grid-template-rows: repeat(4, 25%);
`

export const GridStart = styled(GridSecundaria)`
  grid-column: 1/3;

  ${media.lessThan('medium')`
    grid-column: 1/1;
  `}

  ${media.lessThan('large')`
    grid-column: 1/1;
  `}
`

export const GridCenter = styled(GridSecundaria)`
  grid-column-start: 3;

  ${media.lessThan('medium')`
    grid-column-start: 1;
  `}

  ${media.between('medium', 'large')`
    grid-column-start: 2;
  `}

  ${media.greaterThan('huge')`
   justify-content:center
  `}
`

export const GridEnd = styled(GridSecundaria)`
  grid-column-start: 4;

  ${media.lessThan('medium')`
    grid-column-start: 1;
  `}

  ${media.between('medium', 'large')`
    grid-column-start: 3;
  `}

  ${media.greaterThan('huge')`
   justify-content:end
  `}
`

export const DivCamposStart = styled(DivCampos)`
  grid-template-columns: 180px 1fr;

  ${media.lessThan('medium')`
   grid-template-columns: 220px 1fr;
  `}
`
